/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetEntraSyncStatus200Response
 */
export interface GetEntraSyncStatus200Response {
    /**
     * True while the background sync job has not yet completed.
     */
    syncInProgress?: boolean;
    /**
     * True once the background sync has finished at least once.
     */
    syncComplete?: boolean;
    /**
     * ISO timestamp of the last completed sync, or null if never synced.
     */
    lastSync?: string | null;
}

/**
 * Check if a given object implements the GetEntraSyncStatus200Response interface.
 */
export function instanceOfGetEntraSyncStatus200Response(value: object): value is GetEntraSyncStatus200Response {
    return true;
}

export function GetEntraSyncStatus200ResponseFromJSON(json: any): GetEntraSyncStatus200Response {
    return GetEntraSyncStatus200ResponseFromJSONTyped(json, false);
}

export function GetEntraSyncStatus200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetEntraSyncStatus200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'syncInProgress': json['syncInProgress'] == null ? undefined : json['syncInProgress'],
        'syncComplete': json['syncComplete'] == null ? undefined : json['syncComplete'],
        'lastSync': json['lastSync'] === undefined ? undefined : json['lastSync'] === null ? null : json['lastSync'],
    };
}

export function GetEntraSyncStatus200ResponseToJSON(json: any): GetEntraSyncStatus200Response {
    return GetEntraSyncStatus200ResponseToJSONTyped(json, false);
}

export function GetEntraSyncStatus200ResponseToJSONTyped(value?: GetEntraSyncStatus200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'syncInProgress': value['syncInProgress'],
        'syncComplete': value['syncComplete'],
        'lastSync': value['lastSync'],
    };
}

